import React from 'react';
import { Form, Row } from 'react-bootstrap';
import { IMaskInput } from 'react-imask';

const maskOptions = { mask: '(000) 000-0000' };

export default function Phone2({ id, label, onChange, value }) {
  function handleChange(event) {
    let inputElement = document.getElementById(id);
    let errorElement = inputElement.nextSibling;
    if (event.target.value.trim().length === 0) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The Phone field should not be empty';
      errorElement.style.display = 'block';
    } else if (event.target.value.trim().length < 14) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'You must provide a valid phone number';
      errorElement.style.display = 'block';
    } else {
      errorElement.style.display = 'none';
      inputElement.classList.remove('is-invalid');
    }
    onChange(event, id);
  }
  return (
    <>
      <Form.Group as={Row} controlId={id} className="mb-3">
        <Form.Label column sm={6} required>
          {label}
        </Form.Label>
        <IMaskInput
          className="form-control"
          id={id}
          mask={maskOptions.mask}
          placeholder="(123) 456-7890"
          required
          type="phone"
          pattern=".{14,}"
          maxLength={14}
          onAccept={(value) => handleChange({ target: { name: id, value } })}
          value={value ? value : ''}
          data-hj-allow
        />
        <Form.Control.Feedback type="invalid">
          You must provide a valid phone number
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
